import React from "react"
import { useTranslation } from "react-i18next"
import { connectStateResults } from "react-instantsearch-dom"
import { sprintf } from "sprintf-js"

import styles from "./CustomStateResults.module.scss"

const StateResults = ({ searchState, searchResults, resultsRef }) => {
  const show = searchState?.query?.length
  const hasResults = searchResults && searchResults.nbHits !== 0
  const nbHits = searchResults && searchResults.nbHits

  const { t } = useTranslation()

  let message = ""

  if (!hasResults) {
    message = t("No results found")
  }

  if (hasResults && nbHits === 1) {
    message = sprintf(t("%s result found"), nbHits)
  }

  if (hasResults && nbHits !== 1) {
    message = sprintf(t("%s results found"), nbHits)
  }

  return (
    <div
      hidden={!show}
      className={styles.searchStateResults}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex="0"
      ref={resultsRef}
    >
      <div>{message}</div>
    </div>
  )
}

const CustomStateResults = connectStateResults(StateResults)

export default CustomStateResults
